<template lang="pug">
.li
  .liTop
    .liName {{ pageName }}
    .liTabBlock
      router-link.liTab(
        v-for="item in categories"
        :key="item.label"
        :to="{name: item.key}"
      ) {{item.label}}
  .liTopP
    .liTabBlock
      router-link.liTab(
        v-for="item in categories"
        :key="item.label"
        :to="{name: item.key}"
      ) {{item.label}}
  .liContent
    .liBlock
      h2(v-if="title") ▶{{ title }}
    router-view(:ownerList="ownerList")




</template>

<script>

export default {
  data(){
    return{
      ownerList:[],
      tab: '',
      pageName: '體驗課程',
      cate: ['我要找體驗課程','申請體驗課程','申請進度查詢','文件下載區','申請方式','常見問題'],
      lawsArray: [
        {
         title: '▶ 最新體驗課程',
         data: '',
         category: '我要找體驗課程',
        },
        {
         title: '▶ 申請體驗課程',
         data: '',
         category: '申請體驗課程',
        },
        {
         title: '▶ 申請進度查詢',
         data: '',
         category: '申請進度查詢',
        },
        {
          title: '▶ 文件下載區',
          data: '',
          category: '文件下載區',
        },
        {
          title: '▶ 申請方式',
          data: '',
          category: '申請方式',
        },

        {
          title: '▶ 常見問題',
          data: '',
          category: '常見問題',
        },
        // {
        //   title: '▶ 文化體驗',
        //   data: '',
        //   category: '文化體驗',
        // },
        // {
        //   title: '▶ 藝起來尋美',
        //   data: '',
        //   category: '藝起來尋美',
        // },
      ],
      categories: [
        { key: 'ClassList', label: '我要找體驗課程' },
        // { key: 'ClassApply', label: '申請體驗課程' },
        { key: 'ClassQuery', label: '申請進度查詢' },
        { key: 'ClassApplicationList', label: '文件下載區' },
        { key: 'ClassQuestions', label: '常見問題' },
        // { key: 'ClassFindArtEDU', label: '文化體驗' },
        // { key: 'ClassFindArts', label: '藝起來尋美' },

      ],




    }
  },
  created() {

  },
  mounted() {
    this.tab = this.cate[0]

  },
  methods: {

  },
  computed:{
    title () {
      const target = this.categories.find(e => e.key === this.$route.name)
      return target ? target.label : null
    },
    showlist() {
      var t = this.tab
      return this.lawsArray.filter(function(item) {return JSON.stringify(item.category).indexOf(t)!=-1})
    }
  }
}
</script>
<style>
@charset "UTF-8";
@import url("https://fonts.googleapis.com/css?family=Noto+Sans+TC&display=swap");

ul {
  list-style: none; }

* {
  font-family: '微軟正黑體';
  letter-spacing: 1.5px; }

a {
  text-decoration: none;
  color: black; }

@keyframes fade {
  0% {
    opacity: 0; }
  100% {
    opacity: 1; } }

@keyframes fade-down {
  0% {
    opacity: 0;
    transform: translate(0, -5%); }
  100% {
    opacity: 1;
    transform: translate(0, 0); } }

@keyframes slide-fade1 {
  0% {
    transform: translate(-10%, 0);
    opacity: 0; }
  100% {
    opacity: 1;
    transform: translate(0, 0); } }

@keyframes shakeleft {
  0% {
    opacity: 0.5;
    margin-left: -3%; }
  50% {
    margin-left: -5%;
    opacity: 1; }
  100% {
    opacity: 0.5;
    margin-left: -3%; } }

@keyframes shakeright {
  0% {
    transform: translate(0, 0); }
  50% {
    transform: translate(10%, 0); }
  100% {
    transform: translate(0, 0); } }

@keyframes rot {
  0% {
    transform: rotate(0deg); }
  100% {
    transform: rotate(720deg); } }

@keyframes rot2 {
  0% {
    transform: scale(0.8) rotate(0deg); }
  100% {
    transform: scale(0.8) rotate(720deg); } }

@keyframes changecolorgray {
  0% {
    fill: #D6D7D9; }
  12.5% {
    fill: #C0C2C4; }
  25% {
    fill: #AAABAD; }
  37.5% {
    fill: #939496; }
  50% {
    fill: #AAABAD;
    opacity: 0; }
  62.5% {
    fill: #939496; }
  75% {
    fill: #AAABAD; }
  87.5% {
    fill: #C0C2C4; }
  100% {
    fill: #D6D7D9; } }

@keyframes gray2 {
  0% {
    fill: #f6f6f6; }
  50% {
    fill: #fff;
    opacity: 0; }
  100% {
    fill: #f6f6f6; } }

@keyframes long {
  0% {
    transform: scaleX(1); }
  50% {
    transform: scaleX(1.5); }
  100% {
    transform: scaleX(1); } }

@keyframes short {
  0% {
    transform: scaleX(1); }
  50% {
    transform: scaleX(0.5); }
  100% {
    transform: scaleX(1); } }

@keyframes smaller {
  25% {
    fill: #fff; } }

.mobile_menu_animate-enter, .mobile_menu_animate-leave-to {
  opacity: 0;
  transform: translateY(-10%); }

.mobile_menu_animate-enter-active, .mobile_menu_animate-leave-active {
  transition: all 0.5s; }

.side_animate-enter, .side_animate-leave-to {
  transform: translateX(-100%); }

.side_animate-enter-active, .side_animate-leave-active {
  transition: all 0.5s; }

.fade-enter, .fade-leave-to {
  opacity: 0; }

.fade-enter-active, .fade-leave-active {
  transition: all 0.5s; }

.li {
  position: relative;
  width: 80%;
  margin-top: 6vw;
  margin-left: 10%;
  min-width: 375px; }
  @media all and (max-width: 610px) {
    .li {
      width: 100%;
      margin-left: 0%;
      margin-top: 0vw; } }
  .li .liTop {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: row;
    border-bottom: solid 1px #878787; }
    @media all and (max-width: 900px) {
      .li .liTop {
        height: 4vw;
        margin-top: 1%; } }
    @media all and (max-width: 610px) {
      .li .liTop {
        display: none; } }
    .li .liTop .liName {
      width: 15%;
      font-weight: 800;
      font-size: 30px;
      color: #878787; }
      @media all and (max-width: 900px) {
        .li .liTop .liName {
          width: 20%; } }
    .li .liTop .liTabBlock {
      width: 70%;
      display: flex;
      flex-direction: row; }
      .li .liTop .liTabBlock .liTab {
        font-size: 1vw;
        margin-right: 1vw;
        line-height: 2.5vw;
        letter-spacing: 0.2vw;
        color: #878787;
        cursor: pointer; }
        .li .liTop .liTabBlock .liTab.active {
          color: rgb(170, 5, 5); }
        @media all and (max-width: 900px) {
          .li .liTop .liTabBlock .liTab {
            font-size: 1.8vw;
            line-height: 3.5vw; } }
  .li .liTopP {
    width: 100%;
    height: 20vw;
    position: relative;
    display: none;
    margin-left: 3%; }
    @media all and (max-width: 610px) {
      .li .liTopP {
        display: block;
        min-height: 60px; } }
    .li .liTopP .liName {
      width: 100%;
      font-size: 6vw;
      font-weight: 800;
      line-height: 170%; }
    .li .liTopP .liTabBlock {
      width: 95%;
      position: relative;
      border-bottom: solid 1px #878787;
      padding: 0 0 1.5% 0;
      display: flex;
      flex-direction: row; }
      .li .liTopP .liTabBlock .liTab {
        position: relative;
        font-size: 4vw;
        padding: 1% 1%;
        top: 20%;
        border: solid 1px Black;
        border-color: #878787;
        color: #878787;
        margin-right: 2%;
        text-align: center;
        min-width: 60px; }
        .li .liTopP .liTabBlock .liTab.active {
          background-color: #878787;
          color: white; }

@media all and (-ms-high-contrast: none) and (max-width: 610px), all and (-ms-high-contrast: active) and (max-width: 610px) {
  .li .liTopP .liTabBlock .liTab {
    font-size: 3.5vw; } }
  .li .liContent {
    width: 100%;
    margin-top: 2vw;
    display: flex;
    flex-direction: column; }
    @media all and (max-width: 610px) {
      .li .liContent {
        width: 95%;
        margin-left: 2.5%;
        margin-top: 3vw; } }
    .li .liContent .liLink {
      margin-bottom: 1vw;
      color: #878787;
      font-size: 1.1vw;
      letter-spacing: 0.1vw; }
      @media all and (max-width: 610px) {
        .li .liContent .liLink {
          font-size: 4vw;
          letter-spacing: 0.3vw;
          margin-bottom: 2vw; } }


/*加入明達的CSS*/

.liTabBlock .router-link-active {
  color: rgb(170, 5, 5) !important;
}

</style>



// WEBPACK FOOTER //
// src/views/Artedu1872Class/Class.vue